import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accessToken:     localStorage.getItem('token') || null,
  user:            JSON.parse(localStorage.getItem('user')) || null,
  isLoading:       false,
  isAuthenticated: !!localStorage.getItem('token'),
  error:           null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.accessToken     = action.payload.accessToken;
      state.isAuthenticated = true; 
      state.error           = null;
      state.isLoading       = false;

      localStorage.setItem("token", action.payload.accessToken);

      if (action.payload.user !== undefined) {
        state.user = action.payload.user;
        localStorage.setItem("user", JSON.stringify(action.payload.user));
      }
    },

    setUserData: (state, action) => {
      state.user = action.payload.user;
      localStorage.setItem("user", JSON.stringify(action.payload.user));
    },

    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },

    setError: (state, action) => {
      state.error     = action.payload;
      state.isLoading = false;
    },

    resetCredentials: (state) => {
      state.accessToken     = null;
      state.user            = null;
      state.isAuthenticated = false;
      state.error           = null;
      state.isLoading       = false;

      localStorage.removeItem("token");
      localStorage.removeItem("user");
    },
  },
});

export const {
  setCredentials,
  setUserData,
  setLoading,
  setError,
  resetCredentials,
} = authSlice.actions;

export default authSlice.reducer;